import { supabase } from './supabase.js';

/**
 * Solo lectura: catálogo INE en Supabase (RLS SELECT público).
 */
export async function fetchComunidades() {
  const { data, error } = await supabase
    .from('comunidades')
    .select('id_comunidad,nombre')
    .order('nombre', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function fetchProvinciasByComunidad(idComunidad) {
  const id = Number(idComunidad);
  if (!Number.isFinite(id)) return [];
  const { data: links, error: e1 } = await supabase
    .from('comunidad_provincia')
    .select('id_provincia')
    .eq('id_comunidad', id);
  if (e1) throw e1;
  const ids = [...new Set((links ?? []).map(r => r.id_provincia))];
  if (ids.length === 0) return [];
  const { data: provs, error: e2 } = await supabase
    .from('provincias')
    .select('id_provincia,nombre')
    .in('id_provincia', ids)
    .order('nombre', { ascending: true });
  if (e2) throw e2;
  return provs ?? [];
}

export async function fetchMunicipiosByProvincia(idProvincia) {
  const id = Number(idProvincia);
  if (!Number.isFinite(id)) return [];
  const { data, error } = await supabase
    .from('municipios')
    .select('id_municipio,id_provincia,nombre')
    .eq('id_provincia', id)
    .order('nombre', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

/** Nombre de la CCAA asociada a una provincia (por id). */
export async function fetchComunidadNombreByProvinciaId(idProvincia) {
  const id = Number(idProvincia);
  if (!Number.isFinite(id)) return null;
  const { data: link, error: e1 } = await supabase
    .from('comunidad_provincia')
    .select('id_comunidad')
    .eq('id_provincia', id)
    .limit(1)
    .maybeSingle();
  if (e1 || !link?.id_comunidad) return null;
  const { data: com, error: e2 } = await supabase
    .from('comunidades')
    .select('nombre')
    .eq('id_comunidad', link.id_comunidad)
    .maybeSingle();
  if (e2 || !com?.nombre) return null;
  return String(com.nombre);
}

/** Resuelve CCAA a partir del nombre exacto de provincia en `provincias`. */
export async function fetchComunidadNombreForProvinciaNombre(provinciaNombre) {
  const n = String(provinciaNombre || '').trim();
  if (!n) return null;
  const { data: prov, error } = await supabase
    .from('provincias')
    .select('id_provincia')
    .eq('nombre', n)
    .maybeSingle();
  if (error || !prov?.id_provincia) return null;
  return fetchComunidadNombreByProvinciaId(prov.id_provincia);
}

export async function fetchProvinciaIdByNombre(nombre) {
  const n = String(nombre || '').trim();
  if (!n) return null;
  const { data, error } = await supabase.from('provincias').select('id_provincia').eq('nombre', n).maybeSingle();
  if (error || data?.id_provincia == null) return null;
  return Number(data.id_provincia);
}

export async function fetchComunidadIdByNombre(nombre) {
  const n = String(nombre || '').trim();
  if (!n) return null;
  const { data, error } = await supabase.from('comunidades').select('id_comunidad').eq('nombre', n).maybeSingle();
  if (error || data?.id_comunidad == null) return null;
  return Number(data.id_comunidad);
}
